import React from 'react';
import { useLang } from '../context/LanguageContext';

const PHONE = '966566832802';

const WhatsAppButton = () => {
  const { lang, isRTL } = useLang();
  const messages = {
    en: 'Hello Saudi Investment Bridge, I would like to know more about your services.',
    ar: '\u0645\u0631\u062d\u0628\u0627\u064b \u062c\u0633\u0631 \u0627\u0644\u0627\u0633\u062a\u062b\u0645\u0627\u0631 \u0627\u0644\u0633\u0639\u0648\u062f\u064a\u060c \u0623\u0648\u062f \u0645\u0639\u0631\u0641\u0629 \u0627\u0644\u0645\u0632\u064a\u062f \u0639\u0646 \u062e\u062f\u0645\u0627\u062a\u0643\u0645.',
    zh: '\u4f60\u597d\u6c99\u7279\u6295\u8d44\u6865\u6881\uff0c\u6211\u60f3\u4e86\u89e3\u66f4\u591a\u5173\u4e8e\u4f60\u4eec\u670d\u52a1\u7684\u4fe1\u606f\u3002'
  };
  const msg = encodeURIComponent(messages[lang] || messages.en);
  const url = `https://wa.me/${PHONE}?text=${msg}`;
  const label = lang === 'ar' ? '\u062f\u0631\u062f\u0634\u0629 \u0648\u0627\u062a\u0633\u0627\u0628' : lang === 'zh' ? 'WhatsApp \u804a\u5929' : 'Chat on WhatsApp';

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={label}
      className={`fixed z-40 bottom-6 ${isRTL ? 'left-6' : 'right-6'} group flex items-center gap-2`}
    >
      <span className="hidden sm:inline-block bg-white text-[#0B5D3B] text-xs font-semibold px-3 py-1.5 rounded-full shadow-md opacity-0 group-hover:opacity-100 transition-opacity">
        {label}
      </span>
      <span className="w-14 h-14 rounded-full bg-[#25D366] hover:bg-[#1EBE5D] shadow-lg flex items-center justify-center transition-transform hover:scale-105">
        <svg viewBox="0 0 32 32" width="28" height="28" aria-hidden="true">
          <path fill="#ffffff" d="M19.1 17.3c-.3-.1-1.7-.8-1.9-.9-.3-.1-.5-.1-.7.2-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.5-2.4-1.5-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6.1-.1.3-.3.4-.5.1-.2.2-.3.3-.5.1-.2.1-.4 0-.5-.1-.1-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.7.4-.2.3-1 .9-1 2.3s1 2.7 1.2 2.9c.2.2 2.1 3.2 5.1 4.5.7.3 1.3.5 1.7.6.7.2 1.4.2 1.9.1.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.3.2-1.4-.1-.2-.3-.3-.6-.4z"/>
          <path fill="#ffffff" d="M27.3 4.7C24.3 1.7 20.3 0 16 0 7.2 0 .1 7.1.1 15.9c0 2.8.7 5.5 2.1 7.9L0 32l8.4-2.2c2.3 1.3 4.9 1.9 7.5 1.9h.1c8.8 0 15.9-7.1 15.9-15.9 0-4.3-1.7-8.2-4.6-11.1zM16 29.1h-.1c-2.4 0-4.7-.6-6.7-1.9l-.5-.3-5 1.3 1.3-4.9-.3-.5c-1.3-2.1-2-4.5-2-6.9C2.7 8.5 8.7 2.6 16 2.6c3.5 0 6.9 1.4 9.4 3.9s3.9 5.9 3.9 9.4c0 7.3-6 13.2-13.3 13.2z"/>
        </svg>
      </span>
    </a>
  );
};

export default WhatsAppButton;
